import { Action } from '../types';
import { CoreApplication } from '../utilities/applications';

export interface StaticCobranding {
  application?: CoreApplication;
  derivedApplication?: CoreApplication;
  productHint?: string;
  experience?: string;
}

export type State = StaticCobranding;

export const defaultState: State = {};

const cobranding = (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    default:
      return state;
  }
};

export default cobranding;
